import * as React from "react";
const sizes = {
    xs: 16,
    sm: 20,
    md: 20,
    lg: 24,
    xl: 36,
};
function SvgGym(props) {
    return (React.createElement("svg", Object.assign({ width: sizes[props.size || "lg"], height: sizes[props.size || "lg"], viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M13.0411 6.13519C12.2553 5.34947 12.2553 4.07555 13.0411 3.28983L14.7416 1.58929C15.5273 0.803569 16.8012 0.803568 17.587 1.58929L22.4107 6.41304C23.1964 7.19876 23.1964 8.47268 22.4107 9.2584L20.7102 10.9589C19.9244 11.7447 18.6505 11.7447 17.8648 10.9589L16.1643 9.25841L9.2584 16.1643L10.9589 17.8648C11.7447 18.6506 11.7447 19.9245 10.9589 20.7102L9.2584 22.4107C8.47268 23.1964 7.19876 23.1964 6.41304 22.4107L1.58929 17.587C0.803569 16.8013 0.803568 15.5273 1.58929 14.7416L3.28983 13.0411C4.07555 12.2554 5.34946 12.2554 6.13519 13.0411L7.83572 14.7416L14.7416 7.83573L13.0411 6.13519Z", fill: "currentColor" })));
}
export default SvgGym;
